<div class="table-responsive">
	<table class="table table-rows-rounded table-row-gray-100 align-middle gy-3">
		<thead>
			<tr class="bg-light fw-bolder text-muted">
				@if (showCheckboxDelete) {
					<th class="w-25px ps-6 py-0 pe-0 pay-table-checkbox">
						<div class="form-check form-check-sm form-check-custom form-check-solid">
							<input class="form-check-input" type="checkbox" value="1" />
						</div>
					</th>
				}

				@for (f of fields; track $index) {
					<th
						[class]="f.class"
						[ngClass]="{
							'ps-6': showCheckboxDelete && $index === 0,
						}"
					>
						<span class="d-flex justify-content-between align-items-center cursor-pointer">
							<span class="mt-1" translate>{{ f.label }}</span>
							<div class="d-flex flex-column me-4" *ngIf="f.orderItems">
								<app-keenicon name="up-square" class="fs-8 text-hover-primary"></app-keenicon>
								<app-keenicon name="down-square" class="fs-8 text-hover-primary"></app-keenicon>
							</div>
						</span>
					</th>
				}
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let v of values; let i = index">
				@if (showCheckboxDelete) {
					<td class="ps-6">
						<div class="form-check form-check-sm form-check-custom form-check-solid">
							<input class="form-check-input" type="checkbox" value="1" />
						</div>
					</td>
				}
				<td *ngFor="let f of fields" [class]="f.class">
					<ng-container *ngIf="f.type === 'templated'" [ngTemplateOutlet]="f.template" [ngTemplateOutletContext]="{ values: v, p: i }"></ng-container>
					<div *ngIf="f.type === 'text'">
						{{ v[f.field] | translate }}
					</div>
				</td>
			</tr>
		</tbody>
	</table>
</div>
